import { ReactNode } from 'react';

// @mui
import { alpha, Stack, StackProps, Typography } from '@mui/material';

import { ICContentIcon } from '../../assets/empty';

// ----------------------------------------------------------------------

type EmptyContentProps = StackProps & {
  title?: string;
  filled?: boolean;
  description?: string;
  action?: ReactNode;
  size?: string;
  icon?: ReactNode;
};

export default function EmptyContent({ title, action, filled, icon, size, description, sx, ...other }: EmptyContentProps) {
  return (
    <Stack
      flexGrow={1}
      alignItems="center"
      justifyContent="center"
      sx={{
        px: 3,
        height: 1,
        ...(filled && {
          borderRadius: 2,
          bgcolor: (theme) => alpha(theme.palette.grey[500], 0.04),
        }),
        ...sx,
      }}
      {...other}
    >
      {icon || <ICContentIcon />}

      {title && (
        <Typography variant="body2" component="span" sx={{ mt: 1, color: 'text.disabled', textAlign: 'center' }}>
          {title}
        </Typography>
      )}

      {description && (
        <Typography variant="caption" sx={{ mt: 1, color: 'text.disabled', textAlign: 'center' }}>
          {description}
        </Typography>
      )}

      {action}
    </Stack>
  );
}
